import {AccessLog, Tile} from "../../../model";
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, BarChart, Bar } from 'recharts';
import { ResponsiveContainer } from 'recharts';

type StatGraphProps = {
    data: AccessLog[],
    metric: "date" | "group" | "tile",
    tiles: Tile[]
}

const metrics = {
    date: (logs: AccessLog[]) => {
        const counts = logs.reduce((acc, log) => {
            const day = new Date(log.date).toISOString().slice(0,10);
            acc[day] = (acc[day] || 0) + 1;
            return acc;
        }, {} as Record<string, number>);
        return Object.entries(counts)
            .map(([date, nombre]) => ({ date, nombre }))
            .sort((a, b) => a.date.localeCompare(b.date));
    },

    group: (logs: AccessLog[]) => {
        const counts = logs.reduce((acc, log) => {
            // authGroups est any, on suppose string[]
            (log.authGroups as string[]).forEach(group => {
                acc[group] = (acc[group] || 0) + 1;
            });
            return acc;
        }, {} as Record<string, number>);
        return Object.entries(counts)
            .map(([group, nombre]) => ({ group, nombre }));
    },

    tile: (logs: AccessLog[]) => {
        const counts = logs.reduce((acc, log) => {
            if (!acc[log.tileId]) {
                acc[log.tileId] = { tileId: `${log.tileId}`, nombre: 0 };
            }
            acc[log.tileId].nombre += 1;
            return acc;
        }, {} as Record<number, { tileId: string, nombre: number }>);

        return Object.values(counts);
    }
}


export const StatGraph = (props: StatGraphProps) => {
    const { data, metric } = props;
    const chartData = metrics[metric](data);

    return (
        <div style={{ width: '100%', height: 400 /* ou la hauteur que tu veux */ }}>
            <ResponsiveContainer width="100%" height="100%">
                {metric === "date" ? (
                    <LineChart data={chartData}>
                        <CartesianGrid stroke="#ccc" />
                        <XAxis
                            dataKey="date"
                            tickFormatter={(date) =>
                                new Date(date).toLocaleDateString("fr-FR", {
                                    day: "2-digit", month: "short", year: "numeric"
                                })
                            }
                        />
                        <YAxis />
                        <Tooltip
                            labelFormatter={(date) =>
                                new Date(date).toLocaleDateString("fr-FR", {
                                    weekday: "long", year: "numeric", month: "long", day: "numeric"
                                })
                            }
                        />
                        <Line type="monotone" dataKey="nombre" stroke="#8884d8" />
                    </LineChart>
                ) : (
                    <BarChart data={chartData}>
                        <CartesianGrid stroke="#ccc" />
                        <XAxis
                            dataKey={metric === "group" ? "group" : "tileId"}
                            tickFormatter={
                                metric === "tile"
                                    ? (data) => props.tiles.find(tile => String(tile.id) === String(data))?.name ?? "--"
                                    : undefined
                            }
                        />
                        <YAxis />
                        <Tooltip
                            formatter={(value: any, name: string) => [value, "Nombre"]}
                            labelFormatter={(label) =>
                                metric === "tile"
                                    ? props.tiles.find(tile => String(tile.id) === String(label))?.name ?? "--"
                                    : label
                            }
                        />
                        <Bar dataKey="nombre" fill="#8884d8" />
                    </BarChart>
                )}
            </ResponsiveContainer>
        </div>
    );
}